export const voucherDeLegacy = {
  "voucherOverviewPage.card.subTitle.availableCoupons": "verfügbare {text}",
  "voucher.redemption.message.text.vouchersAsCashback":
    "Erhalten Sie für jeden ausgegebenen {text} einen Cashback-Gutschein."
};
